/**
 * @file 従登録でのメンバー選択
 *
 */
'use strict'

import Common from "../../Utils/Common"

/**
 * @classname SelectAdditionalMember
 * @classdesc 従登録でのメンバー選択
 */
export default class SelectAdditionalMember {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#additional-title-select-member')
	 */
	constructor($e) {
		console.log('SelectAdditionalMember.constructor')
		this._$e = $e
		this._$e.on('change', () => this.onChange());
		this._$btn = $('.btn-approve-additional-title');
		this._$btn.on('click', () => this.onClick());
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof SelectAdditionalMember
	 * @return {undefined}
	 */
	onChange() {
		console.log('SelectAdditionalMember.onChange');
		if(this._$e.val() !== ''){
			this._$btn.prop('disabled', false);
		}else {
			this._$btn.prop('disabled', true);
		}
	}


	/**
	 * clickのコールバック
	 *
	 * @memberof SelectAdditionalMember
	 * @return {undefined}
	 */
	onClick() {
		console.log('SelectAdditionalMember.onClick');
		if(this._$e.val() !== ''){
			$('#additional_member_id').val(this._$e.val());
		}
	}
}
